/* istanbul ignore file */

const escapeRegexToken = (token: string): string => token.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

export const REGULAR_EXPRESSION_CONSTANTS = {
    emailPattern: /^[^@\s]+@[^@\s\.]+(\.[A-Za-z]+)+$/,
    aliasPattern: /[^a-zA-Z0-9]/g,
    regexEscapePattern: /[-\/\\^$*+?.()|[\]{}]/g,
    docTemplateImageSizePattern: /\s*\|\s*Size:\s*[^>]+$/i,
    startsWithTokenPattern: (token: string): RegExp => new RegExp(`^\\s*${escapeRegexToken(token)}`),
    endsWithTokenPattern: (token: string): RegExp => new RegExp(`${escapeRegexToken(token)}\\s*$`),
    hexColorPattern: /^[0-9a-fA-F]{6}$/,
    numberPattern: /^[+-0-9.]+$/,
    noDecimalPlacesNumberPattern: /^\d+$/,
    lettersAndSpacesPattern: /^[a-zA-Z ]*$/,
    phonePattern: /^\+?1?\s*\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
};
